/**
 * Gift Wrapping Service — Scroll Reveal, Stagger & Parallax Animations
 * Shared across all gws-* sections. Loaded once with defer from gws-hero.
 */
document.addEventListener('DOMContentLoaded', function() {
  /* --- Scroll Reveal (IntersectionObserver) --- */
  var reveals = document.querySelectorAll('[data-gws-reveal]');
  var staggers = document.querySelectorAll('[data-gws-stagger]');

  if ('IntersectionObserver' in window) {
    var revealObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          e.target.classList.add('gws-visible');
          revealObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    reveals.forEach(function(el) { revealObs.observe(el); });

    var staggerObs = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (e.isIntersecting) {
          var children = e.target.children;
          for (var i = 0; i < children.length; i++) {
            (function(child, idx) {
              setTimeout(function() { child.classList.add('gws-visible'); }, idx * 120);
            })(children[i], i);
          }
          staggerObs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -30px 0px' });

    staggers.forEach(function(el) { staggerObs.observe(el); });
  } else {
    reveals.forEach(function(el) { el.classList.add('gws-visible'); });
    staggers.forEach(function(el) {
      for (var i = 0; i < el.children.length; i++) el.children[i].classList.add('gws-visible');
    });
  }

  /* --- Parallax (rAF-based, desktop only) --- */
  var isMobile = window.innerWidth < 768;
  if (!isMobile) {
    var parallaxEls = document.querySelectorAll('[data-gws-parallax]');
    var ticking = false;

    function updateParallax() {
      var scrollY = window.pageYOffset;
      parallaxEls.forEach(function(el) {
        var speed = parseFloat(el.getAttribute('data-speed')) || 0.1;
        var rect = el.getBoundingClientRect();
        var center = rect.top + rect.height / 2;
        var offset = (center - window.innerHeight / 2) * speed;
        el.style.transform = 'translate3d(0,' + (-offset).toFixed(1) + 'px,0)';
      });
      ticking = false;
    }

    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(updateParallax);
        ticking = true;
      }
    }, { passive: true });

    updateParallax();
  }
});
